import React, { useState, useEffect } from "react";
import { PublicService } from "services/PublicService";
import Search from "components/MainApp/atoms/Filters/Search";
import styles from "./LocalizationProductFilter.module.scss";
import i18n from "i18n";

const LocalizationProductFilter = ({handleApply}) => {
    const [searchedValue, setSearchedValue] = useState();
    const [products_name, setProducts_name] = useState();

    useEffect(() => {
        PublicService.itemsName({ include_key: 1 }).then((response) => {
            setProducts_name(response);
        });
    }, []);

    return (
        <div className={styles[`localization-filter-panel-container`]}>
            <div className={styles["localization-filter-panel-row"]}>
                <Search
                    placeholder={i18n.t("search.by.name.or.code")}
                    resultList={products_name}
                    value={searchedValue?.label}
                    preventEnterSubmit={true}
                    handleSubmit={(value) => {
                        if (value === "") {
                            handleApply(null);
                        }
                    }}
                    handleSubmitKey={(item) => {
                        setSearchedValue(item);
                        handleApply(item);
                    }}
                />
            </div>
        </div>
    );
};

export default LocalizationProductFilter;
